import { translateOrderTypeItemName } from "../../../common/enums/orderTypes.enum";
export const acceptedOrdersColumns = (t: any) => [
  {
    key: "AcceptedDate",
    name: t('orders.columns.orderNumber'),
    fieldName: "number",
    minWidth: 80,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "CreatedAt",
    name: t('orders.columns.orderDate'),
    fieldName: "createdAt",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "ReceivingDate",
    name: t('orders.columns.acceptedDate'),
    fieldName: "acceptedDate",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "Company",
    name: t('orders.columns.client'),
    fieldName: "company",
    minWidth: 150,
    maxWidth: 250,
    isResizable: true,
  },
  {
    key: "ReceptionPlace",
    name: t('orders.columns.receptionPlace'),
    fieldName: "receptionPlace",
    minWidth: 100,
    maxWidth: 350,
    isResizable: true,
  },
  {
    key: "Quantity",
    name: t('orders.columns.quantity'),
    fieldName: "quantity",
    minWidth: 50,
    maxWidth: 70,
    isResizable: true,
  },
  {
    key: "Type",
    name: t('orders.columns.type'),
    fieldName: "type",
    minWidth: 50,
    maxWidth: 80,
    isResizable: true,
    onRender: (item: any) => {
      const map: any = { "Pojazd": t('orders.typeValues.vehicle'), "Kontener": t('orders.typeValues.container'), "Tonaż": t('orders.typeValues.tonnage'), "Specjalne": t('orders.typeValues.special') };
      return map[item.type] !== undefined ? map[item.type] : item.type;
    },
  },
  {
    key: "OrderTypeItemName",
    name: t('orders.columns.kind'),
    fieldName: "orderTypeItem",
    minWidth: 40,
    maxWidth: 70,
    isResizable: true,
    onRender: (item: any) => translateOrderTypeItemName(item.orderTypeItem, t),
  },
  {
    key: "ContactPhone",
    name: t('orders.columns.phone'),
    fieldName: "contactPhone",
    minWidth: 50,
    maxWidth: 90,
    isResizable: true,
  },
  {
    key: "IsFromCuo",
    name: t('orders.columns.source'),
    fieldName: "isFromCuo",
    minWidth: 80,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "CuoOrderNumber",
    name: t('orders.columns.cuoOrderNumber'),
    fieldName: "cuoOrderNumber",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
  },

];